import { Component } from '@angular/core';
import { SignUpFormComponent } from '../../shared/auth/sign-up-form/sign-up-form.component';
import { TandcComponent } from '../../shared/auth/tandc/tandc.component';
import { VerifyAccountComponent } from '../../shared/auth/verify-account/verify-account.component';
import { SignInFormComponent } from '../../shared/auth/sign-in-form/sign-in-form.component';

@Component({
  selector: 'app-sign-up',
  imports: [
    SignUpFormComponent,
    TandcComponent,
    VerifyAccountComponent,
    SignInFormComponent,
  ],
  templateUrl: './sign-up.component.html',
  styleUrl: './sign-up.component.css'
})
export class SignUpComponent {
  showTerms: boolean = false;
  showVerifyAccount: boolean = false;
  showSignIn: boolean = false;

  getTermsEmitter(e: boolean) {
    this.showTerms = e;
  }

  getFormSubmittedEmitter(e: boolean) {
    this.showVerifyAccount = e;
  }

  getSignInEmitter(e: boolean) {
    this.showSignIn = e;
  }
}
